import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './StudentLogin.css';

const StudentLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Check if admin has set up the system
    const courses = JSON.parse(localStorage.getItem('courses') || '[]');
    if (courses.length === 0) {
      setError('System not initialized. Please ask admin to set up courses first.');
      return;
    }

    // Allow any student to login (or check against registered students)
    const students = JSON.parse(localStorage.getItem('students') || '[]');
    let student = students.find(s => s.email === credentials.email && s.password === credentials.password);
    
    if (!student) {
      // Auto-register new student
      student = {
        id: Date.now().toString(),
        name: credentials.email.split('@')[0],
        email: credentials.email,
        password: credentials.password,
        courses: []
      };
      students.push(student);
      localStorage.setItem('students', JSON.stringify(students));
    }

    const userData = {
      ...student,
      role: 'student'
    };
    
    onLogin(userData);
    navigate('/student-dashboard');
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <Link to="/" className="back-button">← Back</Link>
        
        <div className="login-header">
          <h2>Student Portal</h2>
          <p>Sign in to access your courses</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Sign In
          </button>
        </form>

        <div className="demo-credentials">
          <h4>Student Login:</h4>
          <p>Use any email and password to register</p>
        </div>
      </div>
    </div>
  );
};

export default StudentLogin;